export default {
    Metadata: {
        Name: "Power",
        Description: "Returns the number supplied raised to the given power.",
        Syntax: "Power(number, pow_number)",
        Keywords: ['Math'],
        Author: "DataVoke, Inc.",
    },
    execute(value, power) {
        return Math.pow(value, power);
    },
};

